import React from "react";
import { Column, Columns, Flex, FormInput, Loading, ReadOnly, Toolbar, Subsection } from 'lqx-react';
import { RelationshipModel } from "api/relationship";
import { useEvent, useIO } from "@type-r/react";
import { CpSaveButton } from "../common/api";
import { makeStyles } from '@material-ui/core';
import { Events } from "@type-r/models";

export const CpExternalContacts = ({ $selected, canEdit }: {
    $selected: RelationshipModel,
    canEdit: Boolean
}) => {
    const classes = useStyles();
    const readOnly = React.useContext(ReadOnly) || !canEdit;

    const contact = $selected.cpContact;

    const loadData = async () => {
        await $selected.cpContact.fetch().catch(onError);
    }
    const isReady = useIO(loadData, []);

    useEvent(Events, "cpImport:done", loadData);

    const save = async () => {
        await $selected.cpContact.save();
    }

    const onError = (e) => {
        console.error(e);
    }

    return (
        isReady ? <>
            <ReadOnly.Provider value={readOnly}>
                <AddressSection title="Primary Contact" contact={contact.primaryContact} className={classes.container} />
                <AddressSection title="Secondary Contact" contact={contact.secondaryContact} className={classes.container} />
                <AddressSection title="Tertiary Contact" contact={contact.tertiaryContact} className={classes.container} />
            </ReadOnly.Provider>
            <Toolbar>
                <Flex grow />
                {canEdit && <CpSaveButton onClick={save} label={'Save contacts data?'} isDisabled={!contact.isValid()} />}
            </Toolbar>
        </> : < Loading />
    );
}

const useStyles = makeStyles({
    container: {
        alignItems: "baseline"
    }
});

const AddressSection = ({ title, contact, className }) =>
    <Subsection title={title}>
        <Columns className={className}>
            <Column>
                <FormInput label="Name" $value={contact.$.name} />
                <FormInput label="Job Title" $value={contact.$.jobTitle} />
                <FormInput label="Phone" $value={contact.$.phone} />
                <FormInput label="Street Address" $value={contact.$.streetAddress} />
                <FormInput label="Address Number" $value={contact.$.addressNumber} />
                <FormInput label="City" $value={contact.$.city} />
            </Column>
            <Column>
                <FormInput label="ZIP / Postal Code" $value={contact.$.zipPostalCode} />
                <FormInput label="State / Region" $value={contact.$.stateRegion} />
                <FormInput label="Country" $value={contact.$.country} />
                <FormInput label="Email Address" $value={contact.$.emailAddress} />
                <FormInput label="Escalation Point Name" $value={contact.$.escalationPointName} />
                <FormInput label="Escalation Point Email" $value={contact.$.escalationPointEmail} />
            </Column>
        </Columns>
    </Subsection>             